/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
export function messageRemoveScheduleSuccess() {
  return `Your message is no longer scheduled to send.`;
}

export function messageRemoveScheduleFailure() {
  return `We couldn't remove the schedule date. Send us a message and we'll do our best to help out.`;
}
